/** A single skeleton text bar: the smallest placeholder shape. */

import type { DimensionValue } from 'react-native';

import { BaseSkeleton } from './base-skeleton';

export function TextContainerSkeleton({
    width = undefined as DimensionValue | undefined,
    height = undefined as number | undefined,
    borderRadius = undefined as number | undefined,
    backgroundColor = undefined as string | undefined,
    isLoading = undefined as boolean | undefined,
    fade = undefined as boolean | undefined,
}) {
    return (
        <BaseSkeleton
            borderRadius={borderRadius ?? 2}
            color={backgroundColor}
            fade={fade}
            height={height ?? 6}
            isLoading={isLoading}
            width={(width ?? '100%') as number | string}
        />
    );
}
